export default __webpack_public_path__ + "static/media/individual-recipient-added.bbbde763.png";